import { toast } from 'sonner';
import { useUndoStore } from '@/stores/undoStore';

const UNDO_TOAST_DURATION = 5000;

/**
 * Success toast with an Undo button bound to ITS OWN undo entry. Two stacked
 * toasts each undo their own action — never "whatever is newest on the stack".
 */
export function showUndoToast(message: string, undoEntryId: string): void {
  const toastId = toast(message, {
    duration: UNDO_TOAST_DURATION,
    action: {
      label: 'Undo',
      onClick: async () => {
        toast.dismiss(toastId);
        const success = await useUndoStore.getState().undo(undoEntryId);
        if (success) {
          toast.success('Action undone');
        } else {
          toast.error('Failed to undo');
        }
      },
    },
  });
}

export function showRedoToast(message: string): void {
  toast(message, {
    duration: 2000,
  });
}

export function showUndoSuccessToast(): void {
  toast.success('Action undone');
}

export function showUndoErrorToast(): void {
  toast.error('Failed to undo');
}

export function showRedoSuccessToast(): void {
  toast.success('Action redone');
}

export function showRedoErrorToast(): void {
  toast.error('Failed to redo');
}
